import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import DLeaf from "./DLeaf"

const useStyles = makeStyles(theme => ({
  ["heading-one"]: {
    fontSize: "1em",
    textAlign: "center",
    fontWeight: "bold",
  },
  ["heading-two"]: {
    fontSize: "0.9em",
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 10,
  },
  ["paragraph"]: {
    fontSize: "0.75em",
    marginTop: 10,
    marginBottom: 10,
  },
  ["numbered-list"]: {
    fontSize: "0.75em",
    marginLeft: 30,
    marginTop: 10,
    marginBottom: 10,
    "& li": {
      margin: 0,
    },
  },
  ["bulleted-list"]: {
    fontSize: "0.75em",
    marginLeft: 30,
    marginTop: 10,
    marginBottom: 10,
    "& li": {
      margin: 0,
    },
  },
  tableDiv: {
    width: "100%",
    overflow: "auto",
    fontSize: "0.75em",
  },
  table: {
    fontSize: "0.75em",
    marginTop: 10,
    position: "relative",
    borderCollapse: "collapse",
    borderSpacing: 0,
    display: "table",
    border: "1px solid #000",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,0.2),0 4px 20px 0 rgba(0,0,0,0.19)",
    maxWidth: 600,
  },
  tableCell: {
    border: "solid thin",
    padding: "0.5rem",
    whiteSpace: "pre-wrap",
    verticalAlign: "top",
    padding: 3,
    marginLeft: 3,
  },
}))

const DStarterContent = ({ content, search }) => {
  console.log("DStarterContent", content)
  const classes = useStyles()
  if (!content || content.length === 0) return null

  return content.map(block => {
    console.log("block", block)
    const { type, children } = block
    if (type === "numbered-list") {
      return (
        <ol className={classes[type]}>
          {children.map(inline => {
            return (
              <li>
                {inline.children.map(leaf => {
                  if (leaf.type === "externalLink" && !!leaf.children) {
                    return (
                      <a href={leaf.url} target="_blank">
                        {leaf.children.map(node => (
                          <DLeaf leaf={node} />
                        ))}
                      </a>
                    )
                  }
                  return <DLeaf leaf={leaf} search={search} />
                })}
              </li>
            )
          })}
        </ol>
      )
    }
    if (type === "bulleted-list") {
      return (
        <ul className={classes[type]}>
          {children.map(inline => {
            return (
              <li>
                {inline.children.map(leaf => {
                  if (leaf.type === "externalLink" && !!leaf.children) {
                    return (
                      <a href={leaf.url} target="_blank">
                        {leaf.children.map(node => (
                          <DLeaf leaf={node} />
                        ))}
                      </a>
                    )
                  }
                  return <DLeaf leaf={leaf} search={search} />
                })}
              </li>
            )
          })}
        </ul>
      )
    }
    if (type === "table") {
      return (
        <div className={classes.tableDiv}>
          <table className={classes[type]}>
            {children.map((row, rIndex) => {
              return (
                <tr>
                  {row.children.map(cell => (
                    <td
                      className={classes.tableCell}
                      style={{ fontWeight: rIndex === 0 ? "bold" : "" }}
                    >
                      {cell.children.map(leaf => {
                        if (leaf.type === "externalLink" && !!leaf.children) {
                          return (
                            <a href={leaf.url} target="_blank">
                              {leaf.children.map(node => (
                                <DLeaf leaf={node} />
                              ))}
                            </a>
                          )
                        }
                        return <DLeaf leaf={leaf} search={search} />
                      })}
                    </td>
                  ))}
                </tr>
              )
            })}
          </table>
        </div>
      )
    }
    return (
      <div className={classes[type]}>
        {children.map(leaf => {
          if (leaf.type === "externalLink" && !!leaf.children) {
            return (
              <a href={leaf.url} target="_blank">
                {leaf.children.map(node => (
                  <DLeaf leaf={node} />
                ))}
              </a>
            )
          }
          return <DLeaf leaf={leaf} search={search} />
        })}
      </div>
    )
  })
}

export default DStarterContent
